<template>
  <navigation>
    <router-view />
  </navigation>
</template>

<script>
export default {
  name: "App"
};
</script>
